// Lowercase and strip accents so "electrico" matches "Eléctrico".
export const normalizeText = (value: string): string => {
    return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
}
